import { ReactNode } from 'react'
import { Stack, Title } from 'components'

interface ProjectSectionProps {
  title: string
  children: ReactNode
}

export const ProjectSection = ({ title, children }: ProjectSectionProps) => (
  <Stack spacing={16}>
    <Title order={2} mb={4}>{title}</Title>
    {children}
  </Stack>
)
